import React, { useState, useEffect } from 'react';
import AddBeneficiary from '../beneficiary/shared/add-beneficiary';
import { IGetBeneficiary } from '../../../models/beneficiary.model';
import ExistingBeneficiary from './existing-beneficiary';
import { useBeneficiaryStore } from '../../../store';
import { BsChevronLeft, BsPlus } from 'react-icons/bs';
import usePayoutStore from '../../../store/payout';

interface BeneficiaryDetailsProps {
  beneficiaries: IGetBeneficiary[] | undefined;
}

const BeneficiaryDetails: React.FC<BeneficiaryDetailsProps> = ({
  beneficiaries,
}) => {
  const { resetBeneficiaryPayload } = useBeneficiaryStore();
  const {
    beneficiaryFormState,
    setBeneficiaryFormState,
    setPayoutPayload,
    payoutPayload,
  } = usePayoutStore();

  return (
    <div>
      <div className="flex justify-end">
        {(beneficiaryFormState === 'selected_existing' ||
          beneficiaryFormState === 'add_new') && (
          <div
            className="text-[#0040C2] bg-[#EDF3FF] text-sm flex gap-2 items-center justify-end w-fit cursor-pointer px-2 py-1 rounded"
            onClick={() => setBeneficiaryFormState('select_existing')}
          >
            <BsChevronLeft />
            <p>Select from existing beneficiary</p>
          </div>
        )}
        {beneficiaryFormState === 'select_existing' && (
          <div
            className="text-[#0040C2] bg-[#EDF3FF] text-sm flex gap-2 items-center justify-end w-fit cursor-pointer px-2 py-1 rounded"
            onClick={() => {
              resetBeneficiaryPayload();
              setBeneficiaryFormState('add_new');
              setPayoutPayload({ ...payoutPayload, beneficiaryId: '' });
            }}
          >
            <BsPlus />
            <p>Add new beneficiary</p>
          </div>
        )}
      </div>
      {(beneficiaryFormState === 'selected_existing' ||
        beneficiaryFormState === 'add_new') && (
        <AddBeneficiary caller="payout" addBeneficiary={() => {}} />
      )}
      {beneficiaryFormState === 'select_existing' && (
        <ExistingBeneficiary
          beneficiaries={beneficiaries}
          showAddBeneficiaryForm={() => {
            setBeneficiaryFormState('selected_existing');
          }}
        />
      )}
    </div>
  );
};

export default BeneficiaryDetails;
